/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { IconButton } from "@mui/material";
import { IconPhoto } from "@tabler/icons-react";
import { useCurrentEditor } from "@tiptap/react";
import { ButtonTooltip } from "./toolbar-button/button-tooltip";

const AddImageButton = () => {
    const { editor } = useCurrentEditor();

    function addImage () {
        
        editor.chain().focus().setImage().run();
        
        // TODO: add support for links wrapping images
        // const hasLink = false
        // if (hasLink) {
        //     editor.chain().focus()
        //     .setImage({ src: image.url })
        //     .selectParentNode()
        //     .setLink({ href: link.url })
        //     .run()
        // }
        
    }

    return (
        <ButtonTooltip title={"Add Image"}>
            <IconButton onClick={addImage}>
                <IconPhoto />
            </IconButton>
        </ButtonTooltip>
    );
};

export { AddImageButton };
